import { getUserFromIdToken, IdTokenPayload } from '@/utils/getUserFromIdToken';
import { useMemo } from 'react';

export function useCurrentUser(): IdTokenPayload | null {
  return useMemo(() => getUserFromIdToken(), []);
}
